import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=1bef9de3&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=1bef9de3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bef9de3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bef9de3')) {
      api.createRecord('1bef9de3', component.options)
    } else {
      api.reload('1bef9de3', component.options)
    }
    module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=1bef9de3&scoped=true", function () {
      api.rerender('1bef9de3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/shared/LoadingSpinner.vue"
export default component.exports